import { render, staticRenderFns } from "./OrganisationsList.vue?vue&type=template&id=1cba65a5&scoped=true&"
import script from "./OrganisationsList.vue?vue&type=script&lang=js&"
export * from "./OrganisationsList.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationsList.vue?vue&type=style&index=0&id=1cba65a5&lang=scss&scoped=true&"
import style1 from "./OrganisationsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cba65a5",
  null
  
)

export default component.exports